import React from 'react';
import styled from "styled-components";
import VideoCard from './VideoCard';

const StyledVideoBar = styled.div`
    display: flex; 
    flex-direction: column;
    max-width: 100%; 
    // background-color:#97B4B4; 
    padding: 40px 20px;
    div{
        margin: 0px 20px 32px 0px; 
    }
 `

 class VideoBar extends React.Component {
  constructor(props){
    super(props);
    this.state = {
        items: [
            {
                img: require( '../img/videos/Helen.png'),
                name: 'Helen',
                label: '(Caregiver)',
                desc: 'Helen shares her experience of taking on more of her husband\'s responsibilities.',
                key: 1
            },
            {
                img: require('../img/videos/Samantha.png'),
                name: 'Samantha',
                label: '(Caregiver)',
                desc: 'Samantha cared for her brother\'s three children while he went through transplant.',
                key: 2
            },
        ]
    };
  }

  render(){
    const { items } = this.state;
    return (
        <StyledVideoBar>
            {
                items.map((item) => {
                    return (
                        <VideoCard img={item.img}
                        name={item.name} 
                        label={item.label}
                        desc={item.desc}
                        key={item.key}>
                        </VideoCard>
                    )
                })
            }
        </StyledVideoBar>
    )
}
}

export default class VideoSidebar extends React.Component {
    render() {
      return (
        <VideoBar></VideoBar>
      );
    }
  }